import {
    IContactRequest,
    IContactRequestData,
    IContactRequestPost,
    IContactRequestPostData,
    IContactRequestBase,
    IContactRequestBaseData,
    ContactRequestStatus,
    CONTACT_REQUEST_MESSAGE_MAX_LENGTH,
    CONTACT_VALUE_MAX_LENGTH, IContactRequestPostSimple, IContactRequestPostSimpleData
} from './index'
import {
    IContactRequestHistory,
    ContactRequestHistory
} from './contact-request-history'
import {
    CustomerBase
} from '../customer'

export class ContactRequestBase implements IContactRequestBase {
    message?: string

    constructor(data?: IContactRequestBaseData) {
        this.message = data?.message
    }

    validate(): boolean {
        return this.validateMessage()
    }

    private validateMessage(): boolean {
        let message = this.message
        return !!message && message.length <= CONTACT_REQUEST_MESSAGE_MAX_LENGTH
    }
}

export class ContactRequestPostSimple extends CustomerBase implements IContactRequestPostSimple {
    message?: string
    phone?: string

    constructor(data?: IContactRequestPostSimpleData) {
        super(data);
        this.message = data?.message
        this.phone = data?.phone
    }

    validate(): boolean {
        return super.validate() && this.validateMessage() && this.validatePhone()
    }

    private validateMessage(): boolean {
        let message = this.message
        return !!message && message.length <= CONTACT_REQUEST_MESSAGE_MAX_LENGTH
    }

    private validatePhone(): boolean {
        let phone = this.phone
        return !!phone && phone.length <= CONTACT_VALUE_MAX_LENGTH
    }
}

export class ContactRequestPost extends ContactRequestPostSimple implements IContactRequestPost {
    contact_ways: number[]

    constructor(data?: IContactRequestPostData) {
        super(data);
        this.contact_ways = data?.contact_ways || []
    }

    validate(): boolean {
        return super.validate()
    }
}

export class ContactRequest extends ContactRequestBase implements IContactRequest {
    readonly id?: number
    readonly status: ContactRequestStatus
    readonly history?: IContactRequestHistory[]

    constructor(data: IContactRequestData) {
        super(data)
        this.id = data?.id
        this.message = data?.message
        this.status = data?.status || 'new'

        this.history = data?.history?.map(item => new ContactRequestHistory(item))
    }

    validate(): boolean {
        return super.validate()
    }

    getStatus(): (ContactRequestStatus | undefined) {
        if (this.history) {
            let last = this.history.reduce((l, h) =>
                h.date_creation ?
                  (l.date_creation ?
                    (((new Date(l.date_creation)) > (new Date(h.date_creation))) ?
                      l : h) : h) : l
            )
            return last.status
        }
    }
}
